/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Manage_ButtonInputs */



/**
* | output |
* | --- |
* | "Manage API key" |
*
* @param {Voice_Manager_Elevenlabs_Manage_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_manage_button = /** @type {((inputs?: Voice_Manager_Elevenlabs_Manage_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Manage_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérer la clé API")
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel verwalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci chiave API")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление API-ключом")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrar clave de API")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理 API 密钥")
	if (locale === "ja") return /** @type {LocalizedString} */ ("API キーを管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("API कुंजी प्रबंधित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerir chave de API")
	return /** @type {LocalizedString} */ ("Manage API key")
});